import React, { Component } from 'react';
import config from 'config';
export default class ChatBot extends Component {
  constructor(props) {
    super(props);
    this.chatBotContainerDomId = 'webAdapterHolder';
    this.scriptSrcUrl = config.chatBotUrl;
    this.script = document.createElement('script');
  }

  componentDidMount() {
    this.script.src = this.scriptSrcUrl;
    this.script.async = true;
    document.body.appendChild(this.script);
  }
  componentWillUnmount() {
    this.removeElement(this.script);
    /**TODO: уточнить можно ли избавиться от привязки к ИД
     * нужно, что бы удалять элемент при logout-e*/
    const chatBotContainer = document.getElementById(this.chatBotContainerDomId);
    chatBotContainer ? this.removeElement(chatBotContainer) : null;
  }
  removeElement = (el) => {
    el.remove ? el.remove() : el.parentNode.removeChild(el);
  };
  render() {
    return <></>;
  }
}
